import { render, staticRenderFns } from "./EventDefine2List.vue?vue&type=template&id=65341644&scoped=true&"
import script from "./EventDefine2List.vue?vue&type=script&lang=js&"
export * from "./EventDefine2List.vue?vue&type=script&lang=js&"
import style0 from "./EventDefine2List.vue?vue&type=style&index=0&id=65341644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65341644",
  null
  
)

export default component.exports